<header style="text-align: center;"><h1>Werfy.io</h1></header>
<div class="page" style="padding: 4rem; background-color: #f6f6f7; min-height: 100%;">
  <router-outlet></router-outlet>
</div>
<footer style="text-align: center;">Werfy &copy; 2024</footer>

